import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {unpinCommentMutation} from './__generated__/unpinCommentMutation.graphql'

export function unpinCommentMutation({
  environment,
  input: {id},
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {id: string}
  onCompleted?: () => void
  onError?: (error?: Error) => void
}) {
  return commitMutation<unpinCommentMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation unpinCommentMutation($input: UnpinIssueCommentInput!) @raw_response_type {
        unpinIssueComment(input: $input) {
          clientMutationId
          issueComment {
            id
            isPinned
          }
        }
      }
    `,
    variables: {
      input: {issueCommentId: id},
    },
    optimisticResponse: {
      unpinIssueComment: {
        clientMutationId: '',
        issueComment: {
          id,
          isPinned: false,
        },
      },
    },
    onCompleted: response => {
      if (response.unpinIssueComment === null) {
        onError?.()
      } else {
        onCompleted?.()
      }
    },
    onError: error => onError?.(error),
  })
}
